function loadView(view) {
  return () => import(/* webpackChunkName: "view-[request]" */ `@/components/${view}.vue`)
}

import DivisionRoutes from './divisions'

// Torneos
const routes = [
  {
    path: 'tournaments/all',
    name: 'Tournaments',
    component: loadView('Back/Tournament/List')
  },
  {
    path: 'tournaments/create',
    name: 'TournamentCreate',
    component: loadView('Back/Tournament/AddEdit')
  },
  {
    path: 'tournaments/:tournamentId/edit',
    name: 'TournamentEdit',
    component: loadView('Back/Tournament/AddEdit')
  },
  {
    path: 'tournaments/categories',
    name: 'TournamentCategoriesList',
    component: loadView('Back/Tournament/Categories/List')
  },
  {
    path: 'tournaments/:tournamentId/banners',
    name: 'TournamentBanners',
    component: loadView('Back/Tournament/Banners/List')
  },
  {
    path: 'tournaments/:tournamentId/players',
    name: 'TournamentPlayers',
    component: loadView('Back/Tournament/Players')
  },
  {
    path: 'tournaments/:tournamentId/teams',
    name: 'TournamentBackTeams',
    component: loadView('Back/Tournament/Teams')
  },
  {
    path: 'tournaments/:tournamentId/rules',
    name: 'TournamentBackRules',
    component: loadView('Back/Tournament/Rules')
  },
  {
    path: 'tournaments/:tournamentId/custom-buttons',
    name: 'TournamentBackCustomButtons',
    component: loadView('Back/Tournament/CustomButtons')
  },
  {
    path: 'tournaments/:tournamentId/notices',
    name: 'TournamentBackNotices',
    component: loadView('Back/Tournament/Notices/List')
  },
  {
    path: 'tournaments/:tournamentId/notices/create',
    name: 'TournamentBackNoticesCreate',
    component: loadView('Back/Tournament/Notices/Create')
  },
  {
    path: 'tournaments/:tournamentId/notices/:noticeId/edit',
    name: 'TournamentBackNoticesEdit',
    component: loadView('Back/Tournament/Notices/Edit')
  },
  {
    path: 'tournaments/:tournamentId/administrators',
    name: 'TournamentBackAdministrators',
    component: loadView('Back/Tournament/Administrators')
  },
  {
    path: 'tournaments/:tournamentId/divisions',
    name: 'TournamentBackDivisions',
    component: loadView('Back/Division/List')
  },
  {
    path: 'tournaments/:tournamentId/awards',
    name: 'TournamentBackAwards',
    component: loadView('Back/Tournament/Awards')
  }
]

DivisionRoutes.map(route => {
  routes.push(route)
})

export default routes
